import React from 'react';
import PropTypes from 'prop-types';
import styles from './Auth.module.scss';

const OrDivider = ({ text = 'or' }) => (
  <div className={styles.orDivider} role="separator">
    <span className={styles.orText}>{text}</span>
  </div>
);

OrDivider.propTypes = {
  text: PropTypes.string,
};

export default OrDivider;
